<template>
  <div class="contenitore-ricerca row row-custom">
    <div class="pannello col-24 no-padding" v-loading="filtri.loading">
      <div class="header-search row row-custom">
        <div class="titolo col-22 no-padding">
          {{ filtri.titolo }}
        </div>
        <div class="chiudi col-2 no-padding">
          <icon name="elm-chiudi" scale="1.5" class="pointer" @click.native="closeRicerca"></icon>
        </div>
      </div>
      <div class="content-search">
        <div class="elemento col-24" v-for="(item, index) in filtri.filtri" :key="index">
          <div class="search-label">
            {{ item.myLabel + ':' }}
          </div>

          <select v-if="(item.type === 'select')" v-model="filtri.valueSelected[index]" :disabled="item.ifDisabled"
            @change="changeValueOrClick(index)">
            <option v-for="option in filtri.dati[index]" :value="option[item.value]" :key="option[item.key]">{{
              option[item.label] }}</option>
          </select>

          <!--<el-select v-if="(item.type === 'select')" class="col-24 no-padding" v-model="filtri.valueSelected[index]"
                      placeholder="" :clearable="item.ifClearable"
                      :disabled="item.ifDisabled" @change="changeValueOrClick(index)">
            <el-option v-for="option in filtri.dati[index]"
                        :label="option[item.label]"
                        :key="option[item.key]"
                        :value="option[item.value]">
            </el-option>
          </el-select>-->

          <!--<input v-if="(item.type === 'dt-picker')" type="date" 
            v-model="filtri.valueSelected[index]" @change="changeValueOrClick(index)"/>-->


          <input type="date" v-model="filtri.valueSelected[index]" v-if="(item.type === 'dt-picker')"
            @change="changeValueOrClick(index)" />

          <!--<el-date-picker v-if="(item.type === 'dt-picker')"
                            :format="item.format"
                            :value-format="item.valueFormat"
                            :type="item.typePicker" placeholder=""
                            v-model="filtri.valueSelected[index]"
                            :clearable="item.ifClearable"
                            @change="changeValueOrClick(index)">
          </el-date-picker>-->

          <el-input v-if="(item.type === 'input')" class="col-24 no-padding" v-model="filtri.valueSelected[index]"
            placeholder="" :clearable="item.ifClearable" @change="changeValueOrClick(index)"></el-input>

          <el-checkbox-group v-if="(item.type === 'checkbox')" v-model="filtri.valueSelected[index]">
            <el-checkbox v-for="item in filtri.dati[index]" :label="option[item.value]"
              :key="option[item.key]">{{ item.value }}</el-checkbox>
          </el-checkbox-group>

          <el-checkbox v-if="(item.type === 'checkbox')" v-model="filtri.valueSelected[index]"></el-checkbox>

        </div>

        <div class="col-24">
          <el-button @click="cerca" class="mobile-el-button primary">{{ $t('ricerca.cerca') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RicercaPanel',
  props: {
    filtri: {
      type: Object
    }
  },
  i18n: {
    messages: {
      it_IT: {
        ricerca: {
          cerca: 'Cerca'
        }
      },
      fr_FR: {
        ricerca: {
          cerca: 'Recherche'
        }
      },
      es_ES: {
        ricerca: {
          cerca: 'Búsqueda'
        }
      },
      de_DE: {
        ricerca: {
          cerca: 'Suche'
        }
      },
      en_GB: {
        ricerca: {
          cerca: 'Search'
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    changeValueOrClick: function (index, value) {
      this.$emit('changeValueOrClick', index, value)
    },
    cerca: function () {
      this.$emit('cerca')
    },
    closeRicerca: function () {
      this.$emit('closeRicerca')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../assets/less/general.less";

.el-select-dropdown {
  .el-select-dropdown__item {
    height: 22px;
    line-height: 22px;
    padding: 0px 10px;
    .set-font(@size: 11px; @color: #666);

    span {
      line-height: 22px !important;
    }
  }
}

.contenitore-ricerca {
  height: 100%;
  width: 100%;

  .bg-oscurato {
    height: 100%;
    background-color: #5d5d5d;
    opacity: 0.7;
  }

  .pannello {
    height: 100%;
    background-color: #fff;
    opacity: 1;
    overflow: auto;
    z-index: 10;

    .header-search {
      margin-top: 10px;
      line-height: 20px;
      padding: 0px 15px;
      width: 100%;

      .chiudi {
        text-align: right;

        .pointer:hover {
          cursor: pointer;
        }
      }

      .titolo {
        .set-font(@color: @oroRiva, @size: 24px, @weight: bold, @family: 'os-lightitalic');
        text-align: left;

        letter-spacing: 2px;
        padding-top: 5px;
      }
    }

    .content-search {
      margin-top: 40px;

      .elemento {
        margin-bottom: 20px;

        .search-label {
          float: left;
          .set-font(@color: @greenRiva; @size: 14px);
        }

        .el-date-editor {
          width: 100%;

          .el-input__prefix {
            left: -5px;

            .el-input__icon {
              line-height: 0px;
            }
          }

          .el-input__suffix {
            right: 0px;

            .el-input__icon {
              line-height: 0px;
            }
          }

          .el-input__inner {
            padding-left: 25px !important;
          }
        }

        input {
          .set-font(@family: "os-regular", @size: 14px, @color: #969696);
          border: none;
          border-bottom: 1px solid #007c74;
          border-radius: 0px;
          height: 38px;
          width: 100%;
          padding-right: 24px;
          background-color: #fff;
          text-align: left;
          // margin: 3px;
          padding: 3px;
          -webkit-appearance: none;
        }

        select {
          //.set-font(@family: "os-regular", @size: 12px, @color: #969696);
          border: none;
          border-bottom: 1px solid #007c74;
          height: 38px;
          width: 100%;
          padding-right: 24px;
          background-color: #fff;
          border-radius: 0px;
          text-align: center;
          // margin: 3px;
          padding: 3px;
          -webkit-appearance: none;

          &.first-hours {

            // width: 50%;
            &:after {
              // right: 55%;
            }
          }

          &:focus {
            outline: none;
          }
        }

        .el-checkbox {
          float: right;
          margin-bottom: 0;

          .el-checkbox__inner {
            border-radius: 0;
            height: 20px;
            width: 20px;

            &::after {
              border: 3px solid #FFF;
              height: 10px;
              left: 5px;
              border-left: 0;
              border-top: 0;
            }
          }

          .el-checkbox__inner:hover {
            border-color: @greenRiva;
          }

          &.is-checked {
            .el-checkbox__inner {
              background-color: @greenRiva;
              border-color: @greenRiva;
            }
          }
        }

        .el-select {
          height: 22px;
          line-height: 22px;

          .is-focus {
            border: 0px;
          }

          .el-input {
            .el-input__inner {
              height: 22px !important;
              line-height: 0px;
              padding-left: 0px;
              padding-right: 25px;
              border: 0px;
              border-radius: 0px;
              border-bottom: 1px solid @greenRiva;
              background-color: @white;
              font-size: 12px;
            }

            .el-input__inner:focus {
              border: 0px !important;
              border-bottom: 1px solid @greenRiva !important;
            }
          }

          .el-input__suffix {
            right: 0px;

            .el-input__suffix-inner {
              .el-input__icon {
                line-height: 0px;
              }
            }
          }
        }

        .el-input {
          .el-input__inner {
            height: 22px;
            line-height: 0px;
            padding-left: 0px;
            padding-right: 5px;
            width: 100%;
            border: 0px;
            border-bottom: 1px solid @greenRiva;
            border-radius: 0px;
            font-size: 12px;
          }

          .el-input__suffix {
            right: 0px;
          }
        }

        .div-bottone {
          text-align: right;

          .el-button {
            border: 1px solid @oroRiva;
            background-color: @oroRiva;
            color: @white;
            border-radius: 0px;
            -moz-box-shadow: 3px 3px 4px #cccccc;
            -webkit-box-shadow: 3px 3px 4px #cccccc;
            box-shadow: 3px 3px 4px #cccccc;
            height: 22px;
            line-height: 0px;
            padding: 0px;
            width: 40px;
          }
        }
      }

      .bottoni {
        text-align: right;
        margin-top: 20px;

        .el-button {
          text-transform: uppercase;
          letter-spacing: 4px;
          border: 1px solid @oroRiva;
          background-color: @oroRiva;
          .set-font(@color: @white; @size: 14px);
          border-radius: 0px;
          -moz-box-shadow: 3px 3px 4px #cccccc;
          -webkit-box-shadow: 3px 3px 4px #cccccc;
          box-shadow: 3px 3px 4px #cccccc;
          margin-bottom: 20px;
          padding: 8px 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/RicercaPanelMobile.vue